import Swiper from 'swiper/bundle';
import openBVModal from '../utils/bv';

/**
 * init slider for product detail page
 */
class SingleKfd_product {
    constructor() {
        openBVModal();
        this.initializeSlider();
    }

    initializeSlider() {
        const swiper = new Swiper('.js-gallery-swiper', {
            slidesPerView: 1,
        });

        $('.js-view-image')
            .off('click')
            .on('click', (e) => {
                e.preventDefault();

                $('.js-view-image').removeClass('active');

                $(e.currentTarget).addClass('active');

                const slide = $(e.currentTarget).data('slide');
                swiper.slideTo(slide);
            });
    }
}

/**
 * Check if element is in viewport
 *
 * @param element
 */
function elementInViewport(element) {
    let el = element;
    let top = el.offsetTop;
    let left = el.offsetLeft;
    const width = el.offsetWidth;
    const height = el.offsetHeight;

    while (el.offsetParent) {
        el = el.offsetParent;
        top += el.offsetTop;
        left += el.offsetLeft;
    }

    return (
        top < window.pageYOffset + window.innerHeight &&
        left < window.pageXOffset + window.innerWidth &&
        top + height > window.pageYOffset &&
        left + width > window.pageXOffset
    );
}

/**
 * Initialize Sticky Nav
 *
 */
function stickyNav() {
    const steps = document.querySelectorAll('[data-step]');
    let currentStep = 0;

    // Add some extra padding to the Common Branding Footer
    const commonBrandingFooter = document.querySelector('.common-branding-banner--footer');
    commonBrandingFooter.classList.add('extra-padding');

    $('.js-previous-step').on('click', (e) => {
        e.preventDefault();

        if (currentStep > 0) {
            currentStep -= 1;
            steps[currentStep].scrollIntoView({ behavior: 'smooth' });
        }
    });

    $('.js-next-step').on('click', (e) => {
        e.preventDefault();

        if (currentStep < steps.length - 1) {
            currentStep += 1;
            steps[currentStep].scrollIntoView({ behavior: 'smooth' });
        }
    });

    $('.js-goto-step').on('click', (e) => {
        e.preventDefault();

        const goto = e.currentTarget.getAttribute('data-goto');

        steps.forEach((step, index) => {
            if (step.id === goto) {
                currentStep = index;
                steps[currentStep].scrollIntoView({ behavior: 'smooth' });
            }
        });
    });
}

function initializePage() {
    stickyNav();
    new SingleKfd_product();
}

window.addEventListener('DOMContentLoaded', initializePage);
